import { ColumnHeaderCell } from "./components/Table/Models"

export const UserColumns = (translations: Record<any, any>): ColumnHeaderCell[] => {
	return [
		{
			columnKey: "userName",
			displayName: translations["lang-table-username"],
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "email",
			displayName: translations["lang-table-email"],
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "phoneNumber",
			displayName: translations.phonenumber,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "role",
			displayName: translations["lang-table-role"],
			isSortable: false,
			size: "column-large"
		},
		{
			columnKey: "mobileApp",
			displayName: translations.mobileApp,
			isSortable: false,
			size: "column-large"
		},
		{
			columnKey: "actions",
			displayName: " ",
			isSortable: false,
			size: "column-action-small"
		}
	]
}

export const EducationColumns = (translations: Record<any, any>): ColumnHeaderCell[] => {
	return [
		{
			columnKey: "userName",
			displayName: translations["lang-table-username"],
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "role",
			displayName: translations["lang-table-role"],
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "coursesCompleted",
			displayName: translations.eacompletedinfo,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "bookedCourses",
			displayName: translations.appcsbooked,
			isSortable: true,
			size: "column-large"
		}
	]
}

export const CourseColumns = (translations: Record<any, any>): ColumnHeaderCell[] => {
	return [
		{
			columnKey: "name",
			displayName: translations.courseName,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "level",
			displayName: translations.tmsLevel,
			isSortable: true,
			size: "column-large"
		},
		{
			columnKey: "usersCompleted",
			displayName: translations.userCompleted,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "usersBooked",
			displayName: translations.userBooked,
			isSortable: true,
			size: "column-large"
		},
		{
			columnKey: "mandatoryStatus",
			displayName: translations.mandatory,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "actions",
			displayName: "",
			isSortable: false,
			size: "column-action-small"
		}
	]
}

export const UserEducationColumns = (translations: Record<any, any>): ColumnHeaderCell[] => {
	return [
		{
			columnKey: "name",
			displayName: translations.courseName,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "level",
			displayName: translations.tmsLevel,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "mandatory",
			displayName: translations.mandatory,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "status",
			displayName: translations.statusname,
			isSortable: true,
			size: "column-medium"
		}
	]
}

export const TemplateCreatorList = (translations: Record<any, any>): ColumnHeaderCell[] => {
	return [
		{
			columnKey: "name",
			displayName: translations.name,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "description",
			displayName: translations.description || "Description",
			isSortable: true,
			size: "column-medium"
		 },
		{
			columnKey: "actions",
			displayName: "",
			isSortable: false,
			size: "column-action-small"
		}
	]
}

export const AlertTemplateCreatorList = (translations: Record<any, any>): ColumnHeaderCell[] => {
	return [
		{
			columnKey: "name",
			displayName: translations.name,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "description",
			displayName: translations.classlangmodaldescription || "Description",
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "enabled",
			displayName: translations.enabled || "Enabled",
			isSortable: false,
			size: "column-large"
		},
		{
			columnKey: "actions",
			displayName: "",
			isSortable: false,
			size: "column-action-small"
		}
	]
}